export const scheduleReportConstant = {
  FETCH_SCHEDULE_REPORT_LOADING: 'FETCH_SCHEDULE_REPORT_LOADING',
  FETCH_SCHEDULE_REPORT_SUCCESS: 'FETCH_SCHEDULE_REPORT_SUCCESS',
  FETCH_SCHEDULE_REPORT_FAILURE: 'FETCH_SCHEDULE_REPORT_FAILURE',
};
